import React from 'react';

import { Skeleton } from 'native-base';
import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants';

import { useCheckoutState } from '../../checkout-provider';
import { useCheckoutLoadingState } from '../../hooks';

export const GrandTotalText = () => {
  const [{ tipLoading, totals }] = useCheckoutState();
  const { isOrderPriceLoading } = useCheckoutLoadingState();
  const { formatCurrencyForLocale } = useUIContext();
  const grandTotal = totals?.grandTotal && totals.grandTotal > 0 ? totals.grandTotal : 0;

  if (tipLoading) {
    return <Typography style={styles.totalText}>{t('loading')}</Typography>;
  }

  if (isOrderPriceLoading) {
    return <Skeleton style={styles.grandTotalSkeleton} />;
  }

  return (
    <Typography
      focusable
      accessibilityLabel={`${t('total')}: ${formatCurrencyForLocale(grandTotal)}`}
      style={styles.totalText}
    >
      {t('total') + ': '}
      <Currency
        focusable={false}
        testID="grand-total"
        amount={grandTotal}
        isBold
        textProps={{
          color: primitive.$bbqBrown,
          fontSize: primitive.fontSizes.xl,
          style: { margin: 0, flexGrow: 0 },
        }}
      />
    </Typography>
  );
};

const styles = StyleSheet.create({
  totalText: {
    fontSize: primitive.fontSizes.xl,
    color: primitive.$bbqBrown,
    fontFamily: primitive.fontFamily.$headers,
  },
  grandTotalSkeleton: {
    height: 16,
    width: 120,
    alignSelf: 'center',
    color: primitive.$greyFour,
    marginBottom: 12,
    borderRadius: 100,
  },
});
